import React from 'react';

import PropTypes from 'prop-types';

import { ProductTag } from '~/shared/constants/products';
import { useMembership } from '~/techstyle-shared/react-accounts';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import {
  getProductAvailabilityForUser,
  ProductUserStatus,
} from '~/techstyle-shared/react-products';

import ProductCardSwatchesDesktop from './ProductCardSwatchesDesktop';
import ProductCardSwatchesMobile from './ProductCardSwatchesMobile';

const ProductCardSwatches = ({
  swatches = [],
  activeProductId,
  setActiveProductId = () => {},
  activeProductPdpLink,
}) => {
  const { isMobile } = useBreakpoint();
  const currentUserStatus = useMembership();

  // TODO: check if this functionality is working
  // TODO: ideally pass membership status to the related products api
  // reference: requiredUserStatus in GridSwatches.js
  // check if membershipLevelGroup has the same effect as checking tagIdList for LEAD_ONLY or VIP_ONLY
  const membershipBasedSwatches = swatches.filter((item) => {
    let requiredUserStatus = [];

    if (item?.tagIdList?.includes(ProductTag.leadOnly)) {
      requiredUserStatus = [ProductUserStatus.LEAD_ONLY];
    } else if (item?.tagIdList?.includes(ProductTag.vipOnly)) {
      requiredUserStatus = [ProductUserStatus.VIP_ONLY];
    }

    return getProductAvailabilityForUser({
      currentUserStatus,
      requiredUserStatus,
    });
  });

  return isMobile ? (
    <ProductCardSwatchesMobile
      swatches={membershipBasedSwatches}
      activeProductId={activeProductId}
      setActiveProductId={setActiveProductId}
      activeProductPdpLink={activeProductPdpLink}
    />
  ) : (
    <ProductCardSwatchesDesktop
      swatches={membershipBasedSwatches}
      activeProductId={activeProductId}
      setActiveProductId={setActiveProductId}
      activeProductPdpLink={activeProductPdpLink}
    />
  );
};

ProductCardSwatches.propTypes = {
  activeProductId: PropTypes.number,
  activeProductPdpLink: PropTypes.string,
  setActiveProductId: PropTypes.func,
  swatches: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ),
};

export default ProductCardSwatches;
